export function tf(val) {

    if (typeof val === "string") {

		val = val.replace(/'/, '');

        if (val.indexOf(',') >= 0) {

            val = val.replace(/\./, '');
            val = val.replace(/,/, '.');

        }

    }

    val = parseFloat(val);

    if (isNaN(val)) return 0;
    else return val;

}

export function ff(val, unit, minimumFractionDigits, maximumFractionDigits) {

	if (val === null) return '';

    if (typeof unit === "undefined") unit = ''; else unit = ' ' + unit;
    if (typeof minimumFractionDigits === "undefined") minimumFractionDigits = 2;
    if (typeof maximumFractionDigits === "undefined") maximumFractionDigits = 2;
    if (isNaN(val)) val = tf(val);

    return new Intl.NumberFormat('de-de', {
        minimumFractionDigits: minimumFractionDigits,
        maximumFractionDigits: maximumFractionDigits
    }).format(val).replaceAll(',', '|').replaceAll('.', '.').replaceAll('|', ',') + unit;

}